export default {
	wird: "وِرد",
	contests: "مسابقات",
	wirdLogo: "شعار وِرد",
	getStarted: "ابدأ الآن",
	welcome: "مرحبًا بكم في مسابقات ورد!",
	siteDescription: "ورد عبارة عن منصة غير ربحية ستساعد المعلمين في إنشاء مسابقات مخصصة لطلابهم.",
	ourService: "خدماتنا",
	contactUs: "تواصل معنا",
	adminPanel: "لوحة التحكم",
	introTitle: "عن ورد",
	introText: "تعرف على مشروعنا من خلال الفيديو التالي.",
	ServiceSection: {
		title: "خدماتنا",
		description:
			"تقدم منصة ورد العديد من الخيارات التي تساعد الأوصياء والمعلمين والطلاب على تحسين أدائهم في شهر رمضان.",
		admin: {
			title: "منصة المسؤولين",
			description:
				"موقع إلكتروني للآباء والمعلمين، حيث يمكنهم تخصيص مسابقاتهم ومتابعة إنجازات الأفراد والمجموعات. يمكن للمشرفين استخدام الموقع بما يلي:",
			items: [
				"إنشاء وضبط معايير مسابقاتهم.",
				"رصد أنشطة الطلاب والأطفال من خلال الرسوم البيانية والجداول.",
				"تقسيم الطلاب إلى مجموعات وتعيين مشرف لكل مجموعة.",
				"إنشاء إعلانات على مستوى عام أو خاص.",
			],
		},
		participant: {
			title: "تطبيق للطلاب",
			description:
				"تطبيق لأطفالنا وطلابنا لتسجيل نشاطاتهم اليومية والمنافسة مع الآخرين. يمكن للطلاب استخدام التطبيق كالتالي:",
			items: [
				"تسجيل البيانات والمهمات اليومية.",
				"متابعة أداء الطلاب الشخصي عبر الرسوم البيانية والجداول اليومية للأداء.",
				"التنافس مع مشاركين آخرين في المسابقة.",
			],
		},
	},
	GetStartedSection: {
		title: "لنبدأ",
		description: "خطوة أولى نحو تحفيز طلابك مع مسابقاتنا الشخصية عبر الإنترنت على منصة ورد.",
		iAmCreator: "انا مسؤول",
		forParentsAndTeachers: "للوالدين والمعلمين",
		iAmParticipant: "انا مستخدم",
		forStudentsAndKids: "للطلاب والأطفال",
		downloadNow: "حمل التطبيق الآن",
		asStudentDownloadApp: "كطالب، يمكنك تحميل تطبيق ورد والتسجيل في مسابقتك بسهولة.",
		getOnGooglePlay: "احصل على Google Play",
		downloadOnAppStore: "حمل من App Store",
		downloadOnAppGallery: "حمل من AppGallery",
		startContest: "أنشئ مسابقتك",
		asTeacherSignUp:
			"كمعلم، يمكنك التسجيل وبدء مسابقتك لطلابك باستخدام ورد. على لوحة التحكم الإدارية، ستكون لديك السيطرة على مسابقتك بسهولة.",
		login: "تسجيل الدخول",
		signup: "تسجيل جديد",
		comingSoon: "قريباً",
		comingSoonOnIOS: "قريباً على iOS",
	},
	ContactUsSection: {
		title: "تواصل معنا",
		description: "لبدء مسابقة لمؤسستك، فريقك، أو عائلتك.",
		volunteer: "تطوع معنا",
		inquiries: "للتواصل والاقتراحات",
		followUs: "تابعنا",
		telegram: "قناتنا على تليجرام",
	},
	allRightsReserved: "جميع الحقوق محفوظة © {{year}} وِرد",
	links: "روابط",
	getStudentsApp: "حمل تطبيق الطلاب",
	EmailConfirmPage: {
		loading: "جارٍ تأكيد بريدك الإلكتروني...",
		confirmed: "تم تأكيد البريد الإلكتروني",
		confirmedMessage: "تم تأكيد بريدك الإلكتروني بنجاح. يمكنك الآن تسجيل الدخول إلى حسابك.",
		invalidLink: "رابط غير صالح",
		invalidLinkMessage: "عذرًا، الرابط الذي اتبعته غير صالح. يرجى المحاولة مرة أخرى.",
	},
	ResetPasswordPage: {
		title: "إعادة تعيين كلمة المرور",
		invalidLink: "رابط غير صالح",
		invalidLinkMessage: "عذرًا، الرابط الذي اتبعته غير صالح. يرجى المحاولة مرة أخرى.",
		success: "تم تغيير كلمة المرور بنجاح",
		successMessage: "يمكنك الآن تسجيل الدخول إلى حسابك باستخدام كلمة المرور الجديدة.",
		resetPassword: "إعادة تعيين كلمة المرور",
		newPassword: "كلمة المرور الجديدة",
		confirmNewPassword: "تأكيد كلمة المرور الجديدة",
		enterNewPassword: "أدخل كلمة المرور الجديدة",
	},
	ForgotPasswordPage: {
		title: "نسيت كلمة المرور",
		emailSent: "تم إرسال بريد استعادة كلمة المرور",
		emailSentMessage: "يرجى فحص بريدك الإلكتروني واتباع الإرشادات لإعادة تعيين كلمة المرور.",
		forgotPassword: "نسيت كلمة المرور",
		forgotPasswordFormMessage:
			"أدخل اسم المستخدم والبريد الإلكتروني الخاص بك لإعادة تعيين كلمة المرور.",
		username: "اسم المستخدم",
		email: "البريد الإلكتروني",
		sendResetLink: "إرسال رابط إعادة تعيين",
		forgotUsername: "نسيت اسم المستخدم؟",
	},
	ForgotUsernamePage: {
		title: "استعادة اسم المستخدم",
		forgotUsername: "استعادة اسم المستخدم",
		forgotUsernameFormMessage: "أدخل بريدك الإلكتروني لاستعادة اسم المستخدم.",
		emailSent: "تم إرسال اسم المستخدم",
		emailSentMessage: "يرجى فحص بريدك الإلكتروني واتباع الإرشادات لاستعادة اسم المستخدم.",
		email: "البريد الإلكتروني",
		sendUsername: "إرسال اسم المستخدم",
		forgotPassword: "نسيت كلمة المرور؟",
	},
	soon: "قريباً",
	wirdStats: {
		title: "إحصائيات ورد",
		registeredMembers: "الأعضاء المسجلين",
		createdContests: "المسابقات المنشأة",
		submissions: "المشاركات لاخر 7 أيام",
		contestsPerCountry: "المسابقات حسب الدولة",
		contestsCount_one: "...ومسابقة <strong>واحدة</strong>",
		contestsCount_two: "...و<strong>مسابقتان</strong>",
		contestsCount_few: "...و<strong>{{count}}</strong> مسابقات",
		contestsCount_many: "...و<strong>{{count}}</strong> مسابقة",
		contestsCount_other: "...و<strong>{{count}}</strong> مسابقة",
		inCountries_one: "في دولة <strong>واحدة</strong> أخرى",
		inCountries_two: "في <strong>دولتين</strong> أخريين",
		inCountries_few: "في <strong>{{count}}</strong> دول أخرى",
		inCountries_many: "في <strong>{{count}}</strong> دولة أخرى",
		inCountries_other: "في <strong>{{count}}</strong> دولة أخرى",
	},
	policy: "سياسة الخصوصية",
	help: "المساعدة",
	adminPanelHelp: "مساعدة لوحة التحكم",
	adminPanelHelpText: "شاهد قائمة التشغيل هذه لمعرفة كيفية استخدام لوحة التحكم.",
} as const;
